module.exports = __webpack_public_path__ + "assets/media/level-02.c3e28000.png";